/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/bonz/signIn/signIn.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'bonz/signIn/signIn', exports: {} }; const exports = module.exports;

import loadingBars from '@fd-assets/core-styles/assets/javascripts/src-zugz/loadingBars.js';

import errorNotification from '@grins/fd-modules/bonz/modules/errorNotification';
import utils from '@grins/fd-modules/bonz/modules/utils';

import bonzConsts from '@grins/fd-modules/bonz/shared/constants';

import Fandango_constants_HTTPStatusCodes from '@grins/fd-modules/Fandango/constants';

import inputValidator from '@grins/fd-modules/shared/inputValidator';

import {
  Fandango_adobeLaunch as Fandango_adobeLaunch_track,
  Fandango_xhr as xhr,
  fd_url_manager as links,
  focusableInput_form as focusableForm
} from '@grins/fd-modules/splits/onering-global';

const { HTTPStatusCodes } = Fandango_constants_HTTPStatusCodes;

const { track } = Fandango_adobeLaunch_track;

const Selectors = {
    FORM: '#signin-form',
    SAVE_BTN: '#sign-in-submit-btn',
}
const Msgs = {
    GENERIC_ERROR: 'Something went wrong on our end.  Please try again later.',
    WRONG_PASSWORD: 'The account information you have entered does not match our records. Please try again.',
}
const Styles = {
    HIDE: 'hide',
    LOADING_FULL: 'btn--loading-wrap',
}
function setSaving(isSaving) {
    const saveBtn = document.querySelector(Selectors.SAVE_BTN);
    if (isSaving) {
        loadingBars.start(saveBtn, { className: Styles.LOADING_FULL });
    }
    else {
        loadingBars.stop(saveBtn);
    }
}
function validateFields(fields) {
    const { ValidationTypes, validate } = inputValidator;
    const { email, password } = fields;
    const validationRules = [{
            input: email,
            displayName: 'Email',
            isRequired: true,
            type: ValidationTypes.EMAIL,
        }, {
            input: password,
            displayName: 'Password',
            isRequired: true,
            type: ValidationTypes.CUSTOM,
            failRules: [{
                    regex: '^.{1,7}$',
                    msg: 'Your current password is too short'
                }]
        }];
    const { errors, hasErrors } = validate(validationRules);
    return {
        errors,
        hasErrors
    };
}
function trackError(msg) {
    track({
        event: bonzConsts.OmnitureEvents.SIGNIN_ERROR,
        errorMessage: msg
    });
}
function onFail(err) {
    setSaving(false);
    const status = err && err.status;
    const msg = status === HTTPStatusCodes.FORBIDDEN || status === HTTPStatusCodes.UNAUTHORIZED
        ? Msgs.WRONG_PASSWORD
        : Msgs.GENERIC_ERROR;
    trackError(msg);
    errorNotification.show(msg);
}

function onDone(response: { success: boolean }, email: string, password: string) {
  setSaving(false);

  if (!response || !response.success) {
    return trackError(Msgs.GENERIC_ERROR);
  }

  track(bonzConsts.OmnitureEvents.SIGNIN_COMPLETE);
  utils.addFavorite();
  utils.saveAuthenticationToApp(email, password, 'signin');
  setTimeout(() => window.location.href = utils.getDestinationURI(), 250);
}

async function onSubmit(this: any, e: Event) {
  e.preventDefault();
  errorNotification.hide();
  setSaving(true);
  const fields = this.elements;
  const { errors, hasErrors } = validateFields(fields);

  if (hasErrors) {
    setSaving(false);
    return focusableForm.toggleErrors(errors, true);
  }

  const email: string = fields.email.value;
  const password: string = fields.password.value;
  const data = { email, password };

  xhr.ajax({ url: links.snapiBonzSignIn(), method: 'POST', data })
    .done((response: { success: boolean }) => onDone(response, email, password))
    .fail(onFail);
}

function init() {
  const form = document.querySelector(Selectors.FORM);
  form?.addEventListener('submit', onSubmit);
  focusableForm.attach(form);
}

export default {
    init
};
